import React, { useEffect, useState } from 'react';
import { get } from 'lodash';

import { Button, Input, Textarea, Dropdown } from '../../kaya';
import { authHelpers, generalHelpers } from '../../helpers';
import userStore from '../../zustand/user.store';
import { userActions } from '../../actions';
import { generalConstants } from '../../constants';

import styles from './BusinessDetails.module.scss';

const BusinessDetails = (props) => {
  const { user, setUser, userOffline } = userStore((state) => ({
    user: state.user,
    setUser: state.setUser,
    userOffline: state.userOffline,
  }));
  const [formValues, setFormValues] = useState({
    business_name: '',
    business_address: '',
    business_description: '',
    city: '',
    country: '',
    occupation: '',
    other: '',
  });

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState({
    business_name: '',
    business_address: '',
    business_description: '',
    city: '',
    country: '',
    occupation: '',
    other: '',
  });

  const handleChange = (id) => (value) => {
    if (typeof id !== 'object') {
      setFormValues({
        ...formValues,
        [id]: value,
      });
      setErr({
        ...err,
        [id]: '',
      });
    } else {
      setFormValues({
        ...formValues,
        ...id,
      });
      setErr({
        ...err,
        ...id,
      });
    }
  };
  console.log(user, 'ehgbehb');
  console.log(user.business_occupation, 'user');

  const handleSubmit = async () => {
    const error = {
      business_name: authHelpers.validateBusinessName(
        formValues.business_name
      ),
      business_address: authHelpers.validateAddress(
        formValues.business_address
      ),
      business_description: authHelpers.validateDescription(
        formValues.business_description
      ),
      city: authHelpers.validateCity(formValues.city),
      country: authHelpers.validateCountry(
        user.country
          ? get(user, 'country', '')
          : get(formValues, 'country.value', '')
      ),
      occupation: authHelpers.validateOccupation(
        user.business_occupation
          ? get(user, 'business_occupation', '')
          : get(formValues, 'occupation.value', '')
      ),
      other:
        formValues.occupation.value === 'OTHER'
          ? authHelpers.otherOption(formValues.other)
          : '',
    };

    if (!generalHelpers.isEmptyErrors(error)) {
      setErr({
        ...err,
        ...error,
      });
      return;
    }
    setLoading(true);
    const data = await userActions.updateBusinessInfoAction(
      {
        business_name: formValues.business_name,
        business_address: formValues.business_address,
        business_description: formValues.business_description,
        business_city: formValues.city,
        business_country: formValues.country.value,
        business_occupation:
          formValues.occupation.value === 'OTHER'
            ? formValues.other
            : formValues.occupation.value,
      },
      get(user, 'id', ''),
      userOffline
    );

    if (!data.success) {
      setLoading(false);
      return;
    }

    setUser(data.data);
    setLoading(false);
  };

  const disableButton = () => {
    if (
      formValues.business_name === user.business_name &&
      formValues.business_address === user.business_address &&
      formValues.business_description === user.business_description &&
      formValues.city === user.business_city &&
      formValues.country === user.business_country &&
      formValues.occupation === user.business_occupation
    ) {
      return true;
    }
    return false;
  };
  useEffect(() => {
    setFormValues({
      ...formValues,
      business_name: get(user, 'business_name', ''),
      business_address: get(user, 'business_address', ''),
      business_description: get(user, 'business_description', ''),
      city: get(user, 'business_city', ''),
      country: get(user, 'business_country', ''),
      occupation:
        get(user, 'business_occupation', '') === 'EMPLOYEE' ||
        get(user, 'business_occupation', '') === 'STUDENT' ||
        get(user, 'business_occupation', '') === 'SELF_EMPLOYED'
          ? get(user, 'business_occupation', '')
          : { value: 'OTHER', label: 'Other' },

      other:
        get(user, 'business_occupation', '') === 'EMPLOYEE' ||
        get(user, 'business_occupation', '') === 'STUDENT' ||
        get(user, 'business_occupation', '') === 'SELF_EMPLOYED'
          ? ''
          : get(user, 'business_occupation', ''),
    });
  }, [user]);
  console.log(user, 'ejgb');
  return (
    <div className={styles.BusinessDetails}>
      <form className={styles.form}>
        <div className={styles.labelWithinput}>
          <p className={styles.label}>Business Name</p>
          <Input
            className={styles.input1}
            containerClassName={styles.inputcontainer}
            id='business_name'
            placeholder='Business Name'
            value={formValues.business_name}
            onChange={handleChange('business_name')}
            errors={err}
          />
        </div>
        <div className={styles.labelWithinput}>
          <p className={styles.label}>Address</p>
          <Input
            className={styles.input}
            containerClassName={styles.inputcontainer}
            placeHolder='Business address'
            value={formValues.business_address}
            id='business_address'
            onChange={handleChange('business_address')}
            errors={err}
          />
        </div>
        <div className={styles.labelWithinput}>
          <p className={styles.label}>City</p>
          <Input
            className={styles.input}
            containerClassName={styles.inputcontainer}
            placeHolder='City'
            value={formValues.city}
            id='city'
            onChange={handleChange('city')}
            errors={err}
          />
        </div>
        <div className={styles.labelWithinput}>
          <p className={styles.label}>Country</p>
          <Dropdown
            className={styles.input}
            containerClassName={styles.inputcontainer}
            placeholder='Country'
            options={generalConstants.countries}
            value={formValues.country}
            errors={err}
            id='country'
            onMenuItemClick={handleChange('country')}
          />
        </div>
        <div className={styles.labelWithinput}>
          <p className={styles.label}>Occupation</p>
          <Dropdown
            className={styles.input}
            containerClassName={styles.inputcontainer}
            placeholder='Occupation'
            options={generalConstants.occupations}
            value={formValues.occupation}
            errors={err}
            id='occupation'
            onMenuItemClick={handleChange('occupation')}
          />
        </div>

        {formValues.occupation.value === 'OTHER' && (
          <div className={styles.labelWithinput}>
            <p className={styles.label}>Other</p>
            <Input
              className={styles.input}
              containerClassName={styles.inputcontainer}
              placeHolder='Occupation'
              value={formValues.other}
              id='other'
              onChange={handleChange('other')}
              errors={err}
            />
          </div>
        )}
        {/* 
        {formValues.occupation.value === 'OTHER' && (
          <div className={styles.labelWithinput}>
            <p className={styles.label}>Other</p>
            <Input
              className={styles.input}
              containerClassName={styles.inputcontainer}
              placeHolder='Occupation'
              value={formValues.other}
              id='other'
              onChange={handleChange('other')}
              errors={err}
            />
          </div>
        )} */}
        <div className={styles.labelWithinput}>
          <p className={styles.label}> Description</p>
          <Textarea
            className={styles.input1}
            placeHolder='Business description'
            value={formValues.business_description}
            onChange={handleChange('business_description')}
            error={err.business_description}
            onEnterClick={() => {
              console.log('Enter clicked');
            }}
          />
        </div>
        <div className={styles.btnContainer}>
          <Button
            type='Primary'
            className={styles.btn}
            onClick={handleSubmit}
            disabled={disableButton()}
            isLoading={loading}>
            Save
          </Button>
        </div>
      </form>
    </div>
  );
};

export default BusinessDetails;
